import * as R from "ramda";

import { createHandlers } from "redux-mvc";

import { NAMESPACE, FIELD_IDS, FIELD_IDS_ACTIVE_ACCOUNT } from "./constants";

const iniState = {
  loading: true,
  saving: false,
  visibleFieldIds: [],
  lockedFieldIds: [],
  fields: [],
  loadingContacts: false,
  accountContacts: [],
  contactMembers: [],
  enableAdditionalContacts: false,
  bio: {},
  data: {
    [FIELD_IDS.BIOGRAPHY]: null,
    [FIELD_IDS.SALUTATION]: null,
    [FIELD_IDS.LAST_NAME]: null,
    [FIELD_IDS.FIRST_NAME]: null,
    [FIELD_IDS.HONORIFIC]: null,
    [FIELD_IDS.PRONOUNS]: null,
    [FIELD_IDS.GENDER]: null,
    [FIELD_IDS.TITLE]: null,
    [FIELD_IDS.COMPANY]: null,
    [FIELD_IDS.COMMUNICATION_EMAIL]: null,
    [FIELD_IDS.PHONE_NUMBER]: null,
    [FIELD_IDS.LANGUAGES]: null,
    [FIELD_IDS.REGION]: null,
    [FIELD_IDS.ADDRESS]: null,
    [FIELD_IDS.ADDRESS_LINE_2]: null,
    [FIELD_IDS.CITY]: null,
    [FIELD_IDS.STATE]: null,
    [FIELD_IDS.COUNTRY]: null,
    [FIELD_IDS.ZIP]: null,
    [FIELD_IDS.COUNT_OF_EVENTS]: null,
    [FIELD_IDS.SECONDARY_EMAIL]: null,
    [FIELD_IDS.NEW_RETURNING_SPEAKER]: null,
    [FIELD_IDS.LINKEDIN_URL]: null,
    [FIELD_IDS.TWITTER_URL]: null,
    [FIELD_IDS.FACEBOOK_URL]: null,
    [FIELD_IDS.WEBSITE]: null,

    [FIELD_IDS_ACTIVE_ACCOUNT.GROUP_NAME]: null,
    [FIELD_IDS_ACTIVE_ACCOUNT.DESCRIPTION]: null,
    [FIELD_IDS_ACTIVE_ACCOUNT.TIER]: null,
    [FIELD_IDS_ACTIVE_ACCOUNT.PHONE_NUMBER]: null
  },
  updatedFieldValues: {},
  hasUnSavedChangesModal: false,
  transitionToTabIdAfterSave: false
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    save: R.identity,
    cancel: R.identity,
    onCancelUnsavedChanges: R.identity,
    onConfirmUnsavedChanges: R.identity,
    setInitialData: (
      state,
      {
        payload: {
          bio,
          fields,
          visibleFieldIds,
          lockedFieldIds,
          data,
          contactMembers = [],
          enableAdditionalContacts
        }
      }
    ) => ({
      bio,
      fields,
      visibleFieldIds,
      lockedFieldIds,
      data,
      contactMembers,
      enableAdditionalContacts
    }),
    setUpdatedFieldValue: (state, { payload: { fieldId, value } }) => ({
      updatedFieldValues: {
        ...state.updatedFieldValues,
        [fieldId]: value
      }
    }),
    resetData: R.always(iniState),
    getContactMembers: R.identity,
    getAccountContacts: R.identity,
    deleteContactMembers: R.identity,
    deleteAccountContacts: R.identity
  },

  namespace: NAMESPACE
});

const { getters, actions } = model;

export { getters, actions };

export default model;
